import { Component, OnInit, Input } from '@angular/core';

declare var $;

@Component({
  selector: 'app-a-graph',
  templateUrl: './a-graph.component.html',
  styleUrls: ['./a-graph.component.css']
})
export class AGraphComponent implements OnInit {
  @Input() graphHeight: number;
  @Input() analysisInfo: any;

  public homeChartType: string = 'horizontalBar';
  public homeDataSets: any;
  public homeChartOption: any = {
    responsive: true,                  //グラフ自動設定
    maintainAspectRatio: false,
    legend: {                          //凡例設定
      display: false                 //表示設定
    },
    title: {                           //タイトル設定
      display: false,                 //表示設定
      fontSize: 12,                  //フォントサイズ
    },
    scales: {
      xAxes: [{                         //x軸設定
        display: true,                //表示設定
        barPercentage: 0.4,           //棒グラフ幅
        categoryPercentage: 0.4,      //棒グラフ幅
        scaleLabel: {                 //軸ラベル設定
          display: true,             //表示設定
          labelString: '回答者数(人)',  //ラベル
          fontSize: 12               //フォントサイズ
        },
        ticks: {
          min: 0,
          fontSize: 12,             //フォントサイズ
          stepSize: 10
        },
      }],
    },
    animation: {
        onComplete: function () {
          var ctx = this.chart.ctx;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          var chart = this;
          var datasets = this.config.data.datasets;
  
          datasets.forEach(function (dataset: Array<any>, i: number) {
            ctx.font = "12px Arial";
  
  
            ctx.fillStyle = "Black";
            chart.getDatasetMeta(i).data.forEach(function (p: any, j: any) {
              if (datasets[i].data[j]/p._xScale.end>0.9){
                ctx.fillText(datasets[i].data[j], p._model.x-15, p._model.y);
              }else{
                ctx.fillText(datasets[i].data[j], p._model.x+10, p._model.y);
              }
            });
  
          });
        },
    }
  };

  constructor() { }

  ngOnInit() {
    this.homeDataSets =
      [{
        label: "回答",
        data: this.analysisInfo.data,
      }];
    var w = $('.graph-div').width();
    $('#bar-graph' + this.analysisInfo.q_id).attr('width', w);
    $('#bar-graph' + this.analysisInfo.q_id).attr('height', this.graphHeight);
  }

}



// WEBPACK FOOTER //
// ./src/app/parts/a-graph/a-graph.component.ts